import { Navigate } from 'react-router-dom';
import { Spinner } from '@heroui/react';
import { getPostAuthPath } from '../../features/auth/utils/post-auth-redirect';
import { useAuth } from '../../hooks/useAuth';

/**
 * Cold start do PWA (`start_url: "/"`): espera o bootstrap de auth
 * antes de decidir entre app autenticado e /login.
 */
export default function RootRedirect() {
  const { authUser, userDoc, loading } = useAuth();

  if (loading || (authUser && !userDoc)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Spinner size="lg" />
      </div>
    );
  }

  if (authUser && userDoc) {
    return <Navigate to={getPostAuthPath(userDoc)} replace />;
  }

  return <Navigate to="/login" replace />;
}
